// src/locales/index.js
import en from './en';
import si from './si';
import ta from './ta';

const translations = {
  en,
  si,
  ta
};

export default translations;